import {
  makeInfiniteQueryOptions,
  makeQueryOptions,
} from '@mint-lib/api-zod-support/react-query';

import { defaultApi } from '@mint-sdk/api-core';
import { sub } from 'date-fns';
import { z } from 'zod';

import {
  FilterSchema,
  GetFilterResponseSchema,
  GetResponseSchema,
  ListResponseSchema,
} from './schemas.js';

export const list = defaultApi.declareEndpoint({
  url: 'alerts/list' as const,
  method: 'GET',
  snakeCaseQueryParams: true,
  responseSchema: ListResponseSchema,
  querySchema: FilterSchema,
});

export const listInfiniteQueryOptions = makeInfiniteQueryOptions(
  list,
  {
    processResponse(data) {
      return data;
    },
    getNextPageParam: () => {
      return {
        byDate: {
          dateFrom: sub(new Date(), { days: 90 }),
          dateTo: new Date(),
        },
        campaigns: [],
        platforms: [],
        alertType: [],
      };
    },
  },
  {
    staleTime: 900000, // 15 minutes
    refetchInterval: 1000 * 60 * 5, //  5 minutes to auto refetching is enough.
    refetchOnWindowFocus: false,
  },
);

export const getFilter = defaultApi.declareEndpoint({
  url: 'alerts/list/filters' as const,
  method: 'GET',
  snakeCaseQueryParams: true,
  responseSchema: GetFilterResponseSchema,
  querySchema: FilterSchema,
});

export const getFilterQueryOptions = makeQueryOptions(
  getFilter,
  {
    processResponse(data) {
      return data;
    },
  },
  {
    refetchOnWindowFocus: false,
    refetchInterval: false,
  },
);

export const read = defaultApi.declareEndpoint({
  url: 'alerts/$id/set_read' as const,
  method: 'POST',
  responseSchema: GetResponseSchema,
  requestSchema: z.number(),
});
